var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgParticipants = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99516 5.70195C7.76876 5.70195 9.19749 4.42147 9.19749 2.8455C9.19749 1.26953 7.76876 0 5.99516 0C4.22156 0 2.78051 1.28048 2.78051 2.8455C2.78051 4.41053 4.22156 5.70195 5.99516 5.70195ZM5.99516 0.744208C7.30072 0.744208 8.35996 1.68541 8.35996 2.8455C8.35996 4.00559 7.30072 4.9468 5.99516 4.9468C4.68959 4.9468 3.63036 4.00559 3.63036 2.8455C3.63036 1.68541 4.68959 0.744208 5.99516 0.744208Z",
    fill: "#9CA0AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.427998 10.1562H11.5869C11.8209 10.1562 12.0057 9.99209 12.0057 9.78415C12.0057 7.81418 10.2074 6.20538 7.97811 6.20538H4.03678C1.81978 6.19443 0.00923157 7.80324 0.00923157 9.78415C0.00923157 9.99209 0.193981 10.1562 0.427998 10.1562ZM4.03678 6.94959H7.97811C10.2639 6.94959 9.07272 9.4011 6.78689 9.4011H5.22546C2.94192 9.4011 1.75324 6.94959 4.03678 6.94959Z",
    fill: "#9CA0AA"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgParticipants);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/participants.add41a5a5f3e1a33d829241178bd3730.svg";